import type { ColumnDefinition } from "../../../ui/components/Table/types";
import type { SmartLinkClaim } from "../../lib/api/smart-link";
import type { TranslateValues } from "../../lib/i18n";
import { SmartLinkSyncStatusBadge } from "../../../ui/components/SmartLinkSyncStatusBadge";

function badge(label: string, bg: string, fg: string, border: string) {
  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 600,
        padding: "1px 7px",
        borderRadius: 9999,
        background: bg,
        color: fg,
        border: `1px solid ${border}`,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}

function formatDate(value: string | null): string {
  if (!value) return "—";
  return new Date(value).toLocaleString();
}

export function createSmartLinkClaimsTableColumns(
  t: (key: string, values?: TranslateValues) => string,
): ColumnDefinition<SmartLinkClaim>[] {
  return [
    {
      id: "email",
      label: t("pro.system.smartLink.col.email"),
      sortable: true,
      pinnedLeft: true,
      render: (row) => row.email,
    },
    {
      id: "name",
      label: t("pro.system.smartLink.col.name"),
      render: (row) => {
        const name = [row.firstName, row.lastName].filter(Boolean).join(" ");
        return name || <span style={{ color: "var(--color-fgMuted)" }}>—</span>;
      },
    },
    {
      id: "linkStatus",
      label: t("pro.system.smartLink.col.linkStatus"),
      render: (row) => {
        if (!row.linkedUserId) {
          return badge(t("pro.system.smartLink.status.unlinked"), "#F3F4F6", "#6B7280", "#E5E7EB");
        }
        if (!row.linkEnabled) {
          return badge(t("pro.system.smartLink.status.disabled"), "#FEF2F2", "#B91C1C", "#FECACA");
        }
        return badge(t("pro.system.smartLink.status.linked"), "#ECFDF5", "#047857", "#A7F3D0");
      },
    },
    {
      id: "linkedUser",
      label: t("pro.system.smartLink.col.linkedProUser"),
      render: (row) =>
        row.linkedUser ? row.linkedUser.email : <span style={{ color: "var(--color-fgMuted)" }}>—</span>,
    },
    {
      id: "syncStatus",
      label: t("pro.system.smartLink.col.syncStatus"),
      render: (row) =>
        row.linkedUserId ? (
          <SmartLinkSyncStatusBadge
            status={row.syncStatus}
            label={t("pro.system.smartLink.badge")}
          />
        ) : (
          <span style={{ color: "var(--color-fgMuted)" }}>—</span>
        ),
    },
    {
      id: "lastSyncedAt",
      label: t("pro.system.smartLink.col.lastSynced"),
      sortable: true,
      render: (row) => (
        <span style={{ fontSize: 13, color: "var(--color-fgMuted)" }}>
          {formatDate(row.lastSyncedAt)}
        </span>
      ),
    },
  ];
}
